module.exports = __webpack_public_path__ + "static/media/cupones.fc6ea45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/aeropost/cupones.png
// module id = 1204
// module chunks = 0